let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6MNAi"), load("425pi"), load("bKvoJ")]).then(() => parcelRequire('aFK6m'));